import { Validator } from '@vista-digital/validator';
import { defaultShowtimeSeatPreviewAssets, showtimeSeatPreviewAssetsValidator } from './assets';
import { defaultShowtimeSeatPreviewConfig, showtimeSeatPreviewConfigValidator } from './config';
import { defaultShowtimeSeatPreviewDisplayText, showtimeSeatPreviewDisplayTextValidator } from './display-text';
import { defaultShowTimeSeatPreviewSubcomponents, showTimeSeatPreviewSubcomponentsValidator } from './subcomponents';
export const defaultShowtimeSeatPreviewProps = {
    showtimeId: undefined,
    assets: defaultShowtimeSeatPreviewAssets,
    config: defaultShowtimeSeatPreviewConfig,
    displayText: defaultShowtimeSeatPreviewDisplayText,
    subcomponents: defaultShowTimeSeatPreviewSubcomponents
};
export const showtimeSeatPreviewPropsValidatorSchema = {
    showtimeId: Validator.nonEmptyString,
    assets: showtimeSeatPreviewAssetsValidator,
    config: showtimeSeatPreviewConfigValidator,
    displayText: showtimeSeatPreviewDisplayTextValidator,
    subcomponents: showTimeSeatPreviewSubcomponentsValidator
};
export const showtimeSeatPreviewPropsValidator = Validator.object(showtimeSeatPreviewPropsValidatorSchema);
//# sourceMappingURL=props.js.map